import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import Button from '../components/ui/Button';
import Input from '../components/ui/Input';
import { auth } from '../lib/auth';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiAlertTriangle, FiArrowRight } = FiIcons;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Redirect if already logged in
    if (auth.isAuthenticated()) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!username.trim() || !password.trim()) {
      setError("Please enter both username and password");
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      await auth.login(username.trim(), password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || "Login failed. Please check your credentials.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout hideActions={true}>
      <div className="max-w-sm mx-auto space-y-8 py-12">
        <div className="text-center space-y-4">
          <div className="w-20 h-20 bg-red-600 rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-2xl shadow-red-900/30 transform -rotate-6">
            <SafeIcon icon={FiLock} className="text-4xl text-white" />
          </div>
          <h1 className="text-3xl font-bold">Admin Login</h1>
          <p className="text-zinc-400">Access the ConnectKard dashboard</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6 bg-zinc-900/50 p-6 rounded-2xl border border-zinc-800">
          <Input
            label="Username"
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError('');
            }}
            className="text-base"
            autoComplete="username"
          />

          <Input
            label="Password"
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError('');
            }}
            className="text-base"
            autoComplete="current-password"
          />

          {error && (
            <div className="text-center p-3 bg-red-500/10 border border-red-500/20 rounded-xl text-red-500 text-xs flex items-center justify-center gap-2">
              <SafeIcon icon={FiAlertTriangle} />
              {error}
            </div>
          )}

          <Button type="submit" disabled={isLoading}>
            {isLoading ? "Signing in..." : "Sign In"}
            <SafeIcon icon={FiArrowRight} />
          </Button>
        </form>

        <div className="text-center">
          <p className="text-xs text-zinc-600 mb-2">Authorized personnel only</p>
          <p className="text-xs text-zinc-700">
            Need an account? Contact system administrator
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default AdminLogin;